"use client";

import { CreateGameDialog } from "@/app/oyun/_components/CreateGameDialog";
import Link from "@/components/localized-link";
import { Button } from "@/components/shadcn/button";
import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger,
    navigationMenuTriggerStyle,
} from "@/components/shadcn/navigation-menu";
import { useSession } from "@/lib/auth/client";
import { useTranslations } from "next-intl";
import {
    communityLinks,
    puzzleLinks,
    storeLink,
    videoLinks,
} from "./nav-links";
import { useNavbarPlay } from "./use-navbar-play";

export function NavbarDesktopMenu() {
    const t = useTranslations("nav");
    const { data: session } = useSession();
    const isAuthenticated = Boolean(session?.user);
    const { isCreateGameDialogOpen, setIsCreateGameDialogOpen, startPlaying } =
        useNavbarPlay(isAuthenticated);

    return (
        <div className="hidden lg:block">
            <NavigationMenu aria-label={t("menu")} viewport={false}>
                <NavigationMenuList>
                    <NavigationMenuItem>
                        <NavigationMenuTrigger>
                            {t("videos")}
                        </NavigationMenuTrigger>
                        <NavigationMenuContent>
                            <ul className="whitespace-nowrap">
                                {videoLinks.map((link) => (
                                    <li key={link.href}>
                                        <NavigationMenuLink asChild>
                                            <Link href={link.href}>
                                                {t(link.labelKey)}
                                            </Link>
                                        </NavigationMenuLink>
                                    </li>
                                ))}
                            </ul>
                        </NavigationMenuContent>
                    </NavigationMenuItem>

                    <NavigationMenuItem>
                        <NavigationMenuTrigger>
                            {t("bulmacalar")}
                        </NavigationMenuTrigger>
                        <NavigationMenuContent>
                            <ul className="whitespace-nowrap">
                                {puzzleLinks.map((link) => (
                                    <li key={link.href}>
                                        <NavigationMenuLink asChild>
                                            <Link href={link.href}>
                                                {t(link.labelKey)}
                                            </Link>
                                        </NavigationMenuLink>
                                    </li>
                                ))}
                            </ul>
                        </NavigationMenuContent>
                    </NavigationMenuItem>

                    <NavigationMenuItem>
                        <NavigationMenuLink
                            asChild
                            className={navigationMenuTriggerStyle()}
                        >
                            <Button
                                type="button"
                                variant="ghost"
                                onClick={startPlaying}
                            >
                                {t("oyna")}
                            </Button>
                        </NavigationMenuLink>
                    </NavigationMenuItem>

                    <NavigationMenuItem>
                        <NavigationMenuLink
                            asChild
                            className={navigationMenuTriggerStyle()}
                        >
                            <Link href="/etkinlikler">{t("etkinlikler")}</Link>
                        </NavigationMenuLink>
                    </NavigationMenuItem>

                    <NavigationMenuItem>
                        <NavigationMenuTrigger>
                            {t("other")}
                        </NavigationMenuTrigger>
                        <NavigationMenuContent>
                            <ul className="whitespace-nowrap">
                                <li>
                                    <NavigationMenuLink asChild>
                                        <Link href="/egitmenler">
                                            {t("egitmenler")}
                                        </Link>
                                    </NavigationMenuLink>
                                </li>
                                {communityLinks
                                    .filter(
                                        (link) => link.href !== "/etkinlikler",
                                    )
                                    .map((link) => (
                                        <li key={link.href}>
                                            <NavigationMenuLink asChild>
                                                <Link href={link.href}>
                                                    {t(link.labelKey)}
                                                </Link>
                                            </NavigationMenuLink>
                                        </li>
                                    ))}
                                <li>
                                    <NavigationMenuLink asChild>
                                        <Link href={storeLink.href}>
                                            {t(storeLink.labelKey)}
                                        </Link>
                                    </NavigationMenuLink>
                                </li>
                            </ul>
                        </NavigationMenuContent>
                    </NavigationMenuItem>
                </NavigationMenuList>

                <CreateGameDialog
                    open={isCreateGameDialogOpen}
                    onOpenChange={setIsCreateGameDialogOpen}
                />
            </NavigationMenu>
        </div>
    );
}
